import React, { Component } from 'react';
import { connect } from 'react-redux';
import { appActions } from '../../../../store/modules/app';
import withModal from '../../../../lib/hoc/withModal';
import OrderModifyDeliveryInfoModal from '../../../../views/app/common/modal/OrderModifyDeliveryInfoModal';

class OrderModifyDeliveryInfoModalContainer extends Component {
  /**
   * 모달 닫기
   */
  closeModal = () => {
    this.props.toggleModal({ name: 'orderModifyDeliveryInfoModal', value: false });
  };

  render() {
    return <OrderModifyDeliveryInfoModal {...this.props} closeModal={this.closeModal} />;
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.app.orderModifyDeliveryInfoModal.isOpen,
    data: state.app.orderModifyDeliveryInfoModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: appActions.appToggleModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(OrderModifyDeliveryInfoModalContainer));
